import Header from '../components/Header';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const ContactPage = () => {
  return (
    <>
      <Header />
      <div style={{marginTop: '64px'}}>
        <Contact />
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default ContactPage;
